import SRC_textImg from '../assets/TEXT.png';
import SRC_logo from '../assets/Logo/Logo@3x.png';

function Rules() {
    return (
        <div className="w-full h-fit overflow-x-hidden flex flex-col justify-start items-center">
            <div className="w-[85%] my-12 flex flex-col justify-center items-center gap-4">
                <img className="mx-auto w-3/4 sm:w-1/4" src={SRC_textImg} alt="textImg" />
                <h1 className="font-sans text-2xl font-medium text-[#d8a051]">2026 Elevation Staff Fitness Challenge</h1>

                <div className="text-left text-black">
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">WHY WAR-SHIP?</h2>
                    <p className="font-sans text-base font-normal">
                        We are in a daily spiritual battle. Our bodies, habits, and minds are battlegrounds - and we must put on the armor of God.
                    </p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>Movement is worship</li>
                        <li>Self-control is worship</li>
                        <li>Rest and renewal are worship</li>
                        <li>Caring for our body (your temple) is worship</li>
                    </ul>
                    <br />
                    <p className="font-sans text-base font-normal">Train your body. Guard your mind. Strengthen your spirit.</p>
                    <br className="my-4" />
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">WHAT</h2>
                    <p className="font-sans text-base font-normal">
                        Everyday WAR-Ship is a 30-day habit challenge for <b>Staff & Spouses</b> designed to help you train your body, guard your mind, and
                        strengthen your spirit. Each day, you'll follow a simple Daily Battle Plan built around three pillars:
                    </p>
                    <br />
                    <p className="font-sans text-base font-normal">
                        <b>Work • Abstain • Renew = W.A.R.</b>
                    </p>
                    <br />
                    <p className="font-sans text-base font-normal">
                        Participants earn points daily by choosing intentional habits that reflect discipline, faith, and health - all as an act of worship.
                    </p>
                    <br className="my-4" />
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">DAILY BATTLE PLAN (UP TO 4 POINTS PER DAY)</h2>
                    <p className="font-sans text-base font-bold">W - WORK (1 Point)</p>
                    <p className="font-sans text-base font-normal">
                        Move your body daily as an act of worship. Choose <b>ONE</b>:
                    </p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>45 minutes of intentional exercise (strength and/or cardio)</li>
                        <li>115 Myzone workout MEPs (contact Buck Buhler to get set up)</li>
                        <li>10,000 steps</li>
                        <li>*The Training Standard: This isn't just a walking challenge; it's about stewardship and training. To be eligible for the Top Team Prize, <b>at least 3 days per</b> week must be dedicated to intentional strength training, dedicated cardio, or rucking.*</li>
                    </ul>
                    <br className="my-2" />
                    <p className="font-sans text-base font-bold">A - ABSTAIN (Up to 2 Points)</p>
                    <p className="font-sans text-base font-normal">
                        Practice discipline by intentionally removing distractions or temptations. Choose <b>ANY TWO</b>:
                    </p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>No added/refined sugar</li>
                        <li>No grains</li>
                        <li>Social Media Blackout (Total social media fast - see <a href="/faq"><u>FAQs</u></a>)</li>
                    </ul>
                    <p className="font-sans text-base font-normal italic">(Max: 2 points per day) <a href='/nutrition'><u>Nutrition Info</u></a></p>
                    <br className="my-2" />
                    <p className="font-sans text-base font-bold">R - RENEW (1 Point)</p>
                    <p className="font-sans text-base font-normal">
                        Guard your mind and renew your spirit. Choose <b>ONE</b>:
                    </p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>20+ minutes of focused Bible Study or spiritual biblical growth reading (focused time on studying the Bible)</li>
                        <li>No devices for 1-2 hours before bed</li>
                        <li>7+ hours of sleep</li>
                    </ul>
                    <br className='my-4' />
                    <p className="font-sans text-base font-normal">
                        All points will have a 24 hour grace period to be logged in the challenge platform before they expire.
                    </p>
                    <br className="my-4" />
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">BONUS: eGROUP PARTICIPATION (Optional)</h2>
                    <p className="font-sans text-base font-normal">Community matters. Sharpen the sword.</p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>Join and ATTEND your weekly eGroup (must join)</li>
                        <li>Attend the weekly <a href='https://docs.google.com/forms/d/e/1FAIpQLSe5zwkGIrPMwA3Nbr72CFh8TBJnj0mfpym2Qr0lXAJ3Ix9Suw/viewform'><u>Staff Bible Study with LB</u></a> (Galatians)</li>
                        <li>+2 bonus points per week</li>
                        <li>Max bonus: 8 points total</li>
                    </ul>
                    <br />
                    <p className="font-sans text-base font-normal italic">(Bonus points are encouraged but are not required for completion.)</p>
                    <br className="my-4" />
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">WHEN</h2>
                    <ul className="font-sans text-base font-normal">
                        <li>Wednesday, January 21 - Thursday, February 19</li>
                    </ul>
                    <br className="my-4" />
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">POINTS & TIERS (30 DAYS)</h2>
                    <p className="font-sans text-base font-bold">INDIVIDUAL COMPLETION - TIER 1</p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>85+ points</li>
                        <li>Allows for individual success even if a Battle Partner disengages, has minimal participation, or abandons the mission.</li>
                        <li>$20 gift card</li>
                    </ul>
                    <br className="my-2" />
                    <p className="font-sans text-base font-bold">TEAM COMPLETION (Battle Partners) - TIER 2</p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>100+ points for EACH partner</li>
                        <li>Additional $20 gift card for each - both Battle Partners must complete ($40 total per person)</li>
                    </ul>
                    <br className="my-2" />
                    <p className="font-sans text-base font-bold">GOLD TIER - TIER 3</p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>115+ points EACH partner</li>
                        <li>Additional $20 gift card for each - both Battle Partners must complete ($60 total per person)</li>
                    </ul>
                    <br />
                    <p className="font-sans text-base font-normal italic">Max Possible Points is 128 (including bonus points).</p>
                    <p className="font-sans text-base font-normal italic">
                        Team prizes require <b>BOTH</b> partners to hit the point threshold.
                    </p>
                    <br className="my-4" />
                    <h2 className="font-sans text-xl font-extrabold text-[#8B0000]">TEAMS</h2>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>
                            Participate with a <b>Battle Partner</b> (teams of 2)
                        </li>
                        <li>Partners choose each other</li>
                        <li>If a partner drops, you may continue individually. Team prizes require both partners to complete that Tier.</li>
                    </ul>
                    <br className="my-4" />
                    <p className="font-sans text-xl font-extrabold text-[#8B0000]">TOP TEAM EXPERIENCE PRIZE</p>
                    <ul className="font-sans text-base font-normal list-disc list-inside">
                        <li>The Top 5 performing teams will win a shared Experience Prize</li>
                        <li>Allotted amount for a race or fitness event, spa day, plunge/sauna, whitewater/outdoor experience, overnight hotel stay</li>
                        <li className='pl-4'>1st Place:  Bonus $140 per person</li>
                        <li className='pl-4'>2nd Place:  Bonus $100 per person</li>
                        <li className='pl-4'>3rd Place:  Bonus $75 per person</li>
                        <li className='pl-4'>4th Place:  Bonus $50 per person</li>
                        <li className='pl-4'>5th Place:  Bonus $25 per person</li>
                        <li>
                            Team Tiebreaker - <b>Total Steps Logged</b> - see <a href='/faq'><u>FAQs</u></a>
                        </li>
                    </ul>
                    <br className="my-4" />
                    <p className="font-sans text-base font-normal text-center">
                        ***Contact Buck at <a href="mailto:bbuhler@elevationchurch.org"><u>bbuhler@elevationchurch.org</u></a> with questions.***
                    </p>
                    <br className="my-4" />
                    <h2 className="font-sans text-2xl font-bold text-black text-center">ARE YOU READY TO GO TO W.A.R.??</h2>
                    <h2 className="font-sans text-xl font-bold text-black text-center">EVERYDAY WAR-SHIP</h2>
                    <p className="font-sans text-base font-normal text-center italic">
                        Every day is a battle. Every choice is an opportunity to worship. Let's go to W.A.R.
                    </p>
                </div>

                <img className="w-12 mt-6" src={SRC_logo} alt="logoImg" />
            </div>
        </div>
    );
}

export default Rules;
